import { NormalStatus } from '@/constants/normal-status'
import { Menu } from '@/model/menu'
import { createAppSelector } from '@/redux/utils'
import { createMenuItem } from '@/utils/menu'

export const selectCurrentMenu = createAppSelector([
  (state) => state.menu.menus,
  (state) => state.global.featureKeys,
], (menus, featureKeys) => {
  const menu = menus.find((m) => m.key === featureKeys.at(-1)?.toString())
  const featureConfig = menu ? window.menuConfig[menu.key] : undefined
  return { menu, featureConfig }
})

export const selectMineMenus = createAppSelector(
  [(state) => state.menu.menus, (state) => state.role.mineRoles],
  (menus, mineRoles) => {
    const menusMap = new Map(menus.map((menu) => [menu.id, menu]))
    const mineMenus = mineRoles
      .filter((role) => role.status === NormalStatus.Activated)
      .flatMap((role) => role.menuPermissions)
      .map((mp) => menusMap.get(mp.menuId))
      .filter((m): m is Menu => m !== undefined && window.menuConfig[m.key] !== undefined)

    const parentIds = mineMenus.flatMap((m) => m.parentId)

    return menus.filter((menu) => {
      return (
        parentIds.includes(menu.id) ||
        mineMenus.some((m) => m.key.includes(menu.key))
      )
    })
  },
)

export const selectMenuItems = createAppSelector([selectMineMenus], (mineMenus) => {
  return mineMenus
    .filter((menu) => !menu.parentId)
    .map((menu) => {
      const subItems = mineMenus
        .filter((m) => m.parentId === menu.id)
        .map((menu: Menu) => createMenuItem(menu.key, menu.name))

      return {
        ...createMenuItem(menu.key, menu.name),
        children: subItems.length ? subItems : undefined,
      }
    })
})
